import "./LoaderIcon.css"

export const LoaderIcon = (
    { styles,
        width,
        height
    }: {
        styles?: React.CSSProperties,
        width?: number | string,
        height?: number | string
    },
) => {
    return (
        <div className="loader-icon" style={styles}>
            <img
                src="/icons/loader.png"
                alt="loader-icon"
                style={{
                    width: width,
                    height: height
                }}
            />
        </div>
    )
}